<template lang="pug">
  #neo-number-change
    b-card(header-tag="header")
      neo-number-change-form(:has_special_priced_item="has_special_priced_item")
</template>

<script>
import NeoNumberChangeForm from "@/components/supportSite/NeoNumberChangeForm";

export default {
  name: "NeoNumberChange",
  components: {
    NeoNumberChangeForm,
  },
  props: {
    // 優待価格商品保有フラグ
    has_special_priced_item: { type: Boolean, required: false }
  }
}
</script>

<style scoped>

</style>